<!--
Spinner Component — wraps PrimeVue ProgressSpinner for inline loading indicators.

Use for indeterminate progress (loading states, fetches in flight).
For determinate progress see KpiProgressBar / LoadingProgressBar.
-->

<template>
  <PrimeProgressSpinner v-bind="$attrs" />
</template>

<script setup lang="ts">
import PrimeProgressSpinner from 'primevue/progressspinner';

defineOptions({ name: 'Spinner', inheritAttrs: false });
</script>
